module.exports = __webpack_public_path__ + "static/media/3d_floor.ae458445.png";